import React from 'react';
import { useTranslation } from 'react-i18next';
import './MapActiveFilterChips.css';

/**
 * @param {object} p
 * @param {{ id: string, label: string }[]} p.chips
 * @param {(id: string) => void} p.onDismiss
 */
function MapActiveFilterChips({ chips = [], onDismiss }) {
  const { t } = useTranslation(['discover']);

  if (!Array.isArray(chips) || chips.length === 0) {
    return null;
  }

  return (
    <div
      className="map-active-filter-chips"
      role="toolbar"
      aria-label={t('discover.map.activeFilterChips.toolbarLabel', 'Aktywne filtry mapy')}
    >
      <span className="map-active-filter-chips-heading" aria-hidden="true">
        <span>{t('discover.map.activeFilterChips.headingLine1', 'Aktualne')}</span>
        <span>{t('discover.map.activeFilterChips.headingLine2', 'filtry:')}</span>
      </span>
      <div className="map-active-filter-chips-scroll">
        {chips.map((chip) => (
          <span key={chip.id} className="map-active-filter-chip">
            <span className="map-active-filter-chip-label">{chip.label}</span>
            <button
              type="button"
              className="map-active-filter-chip-remove"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (typeof onDismiss === 'function') {
                  onDismiss(chip.id);
                }
              }}
              aria-label={t('discover.map.activeFilterChips.removeAria', 'Usuń filtr: {{label}}', {
                label: chip.label,
              })}
            >
              <span aria-hidden="true">×</span>
            </button>
          </span>
        ))}
      </div>
    </div>
  );
}

export default MapActiveFilterChips;
